<script setup>
import { ref, onMounted, watch } from 'vue'
import ApiServices from '@/Services/ApiServices'

const props = defineProps({
  nid: { type: [String, Number], required: true },
})

const reports = ref([])
const loading = ref(true)
const error = ref(null)

async function load() {
  loading.value = true
  error.value = null
  try {
    const { data } = await ApiServices.getReports(props.nid)
    // Expecting { data: [...] }
    console.log(data)
    reports.value = Array.isArray(data?.data) ? data.data : []
  } catch (e) {
    console.error('[InspectionReports] failed', e)
    error.value = e?.message || 'Failed to load inspection reports'
  } finally {
    loading.value = false
  }
}

onMounted(load)
watch(() => props.nid, load)
</script>

<template>
  <div class="report-list">
    <div class="d-flex justify-space-between align-center mb-2">
      <span class="text-h5">Inspection reports</span>
      <v-btn
          color="primary"
          variant="flat"
          size="small"
          :to="{ name: 'new_report', params: { nid: props.nid } }"
      >
        Add report
      </v-btn>
    </div>

    <v-skeleton-loader v-if="loading" type="list-item-three-line@5" />

    <v-alert v-else-if="error" type="error" variant="tonal" density="comfortable">
      {{ error }}
    </v-alert>

    <v-alert v-else-if="!reports.length" type="info" variant="tonal" density="comfortable">
      No inspection reports found.
    </v-alert>

    <v-expansion-panels
        v-else
        variant="accordion"
        class="expansion-panels"
        multiple
    >
      <v-expansion-panel
          v-for="report in reports"
          :key="report.nid"
          bg-color="grey-lighten-4"
      >
        <v-expansion-panel-title class="font-weight-medium">
          {{ report.title }}
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <div class="text-overline mb-1">By: {{ report.author }}</div>
          <div
              class="memo mb-3"
              v-html="report.field_memo || '(no summary available)'"
          ></div>

          <v-btn
              color="secondary"
              variant="outlined"
              size="small"
              :to="{ name: 'ireport', params: { uuid: report.uuid } }"
          >
            Open
          </v-btn>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<style scoped>
.report-list {
  margin-top: 1rem;
}
.memo {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
